import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import Text from 'components/Text';
import { ReactSVG } from 'react-svg';
import { delete_icon } from 'asset/icons';
import { fontSizes } from 'appconstants';
import CustomModal from './CustomModal';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';


interface Props {
    isStore?: boolean,
    array: Array<{ storeName?: string, roomName?: string, createdBy: number }>,
    setFieldValue: Function
}
const CustomTable = ({ isStore, array, setFieldValue }: Props) => {

    const { user } = useSelector((state: RootState) => state.common);

    const [showModal, setShowModal] = useState<boolean>(false)

    const onAddRoomStore = (values, functions) => {
        const val = isStore ? "stores" : "rooms"
        const label = isStore ? "storeName" : "roomName"
        setFieldValue(val, [...array, { [label]: values?.name, createdBy: user?.userId }])
        functions.resetForm()
        setShowModal(false)
    }

    const onDelete = (index: number) => {
        const val = isStore ? "stores" : "rooms"
        let arr = [...array]
        const updated_array = arr?.filter((val, ind) => index !== ind)
        setFieldValue(val, updated_array)
    }

    return (
        <div className='min-h-0'>
            <div className='mt-5 rounded-md border bg-white p-5 shadow-sm' >
                <div className='flex items-center justify-between '>
                    <Text text={isStore ? 'Stores' : 'Rooms'} className='font-bold' size={fontSizes.h20} />
                    <Text text={isStore ? 'Add Store +' : 'Add Room +'} size={fontSizes.h18} className='text-primary'
                        onClick={() => setShowModal(true)} />
                </div>
                <div className='rounded-xl border max-h-full overflow-y-auto mt-4'>
                    <Table>
                        <TableHeader>
                            <TableRow className='hover:bg-transparent'>
                                <TableHead className='px-4 text-black py-3 min-w-60'>{isStore ? 'Stores' : 'Rooms'}</TableHead>
                                <TableHead className='text-black min-w-40'>Action</TableHead>

                            </TableRow>
                        </TableHeader>

                        <TableBody>
                            {
                                array?.map((item, index) => (
                                    <TableRow className='hover:bg-muted/50'>
                                        <TableCell className='px-4 py-3'>
                                            <Text text={isStore ? item?.storeName : item?.roomName} className='text-muted-foreground font-medium' />
                                        </TableCell>
                                        <TableCell>
                                            <div className='flex gap-4'>
                                                <div onClick={() => onDelete(index)} className='flex items-center gap-1 cursor-pointer text-destructive'>
                                                    <Text text='Delete' className='text-destructive' />
                                                    <ReactSVG src={delete_icon} />
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }

                        </TableBody>
                    </Table>
                </div>

            </div>

            <CustomModal open={showModal} isStore={isStore} onClose={() => setShowModal(false)} onAdd={onAddRoomStore} />
        </div>
    );
};

export default CustomTable;
